module.exports = __webpack_public_path__ + "img/section2_3.68063981.png";